module.exports = __webpack_public_path__ + "img/thumb_down_colored.7a6e9878.png";